import { render } from "./CreateTemplateModal.vue?vue&type=template&id=33b02841"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/CreateTemplateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b02841"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b02841', __exports__)) {
    api.reload('33b02841', __exports__)
  }
  
  module.hot.accept("./CreateTemplateModal.vue?vue&type=template&id=33b02841", () => {
    api.rerender('33b02841', render)
  })

}


export default __exports__